import {
    Drawer,
    Box,
    useMediaQuery,
    Grid, CircularProgress
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import ConvoNavBar from "../../../messages/components/convoNavBar";
import Convo from "../../../messages/components/convo";
import ConvoFooter from "../../../messages/components/convoFooter";
import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect, useRef } from "react";
import convoBg from '../../../../assests/convoBg.jpg'
import WaIntroBgImage from '../../../../assests/c3crmWaBg.jpg';
import { getWaChatsThunk } from "../../../messages/messagesThunk";
import { SocketProvider } from "../../../../components/socketProvider/socketProvider";

export default function LeadWaChatConvo({ open, handleClose }) {
    const isMobile = useMediaQuery("(max-width:600px)");
    const dispatch = useDispatch();
    const lastMsgRef = useRef(null);
    const { selectedUser, waMessageChats, hasMoreChats, loadingChats, chatPage } = useSelector((state) => state.messages);

    const scrollToLastMsg = () => {
        if (lastMsgRef?.current) {
            lastMsgRef.current.scrollIntoView();
        }
    };

    useEffect(() => {
        if (chatPage === 1) {
            scrollToLastMsg();
        }
    }, [waMessageChats, chatPage]);

    const fetchPreviousChat = () => {
        if (!loadingChats && hasMoreChats && selectedUser !== null) {
            dispatch(
                getWaChatsThunk({
                    credentials: {
                        wa_contact_id: selectedUser,
                        limit: 20,
                        page: chatPage + 1,
                    },
                })
            );
        }
    };


    useEffect(() => {
        if (selectedUser !== null) {
            dispatch(
                getWaChatsThunk({
                    credentials: {
                        wa_contact_id: selectedUser,
                        limit: 20,
                        page: 1,
                    },
                })
            );
        }
    }, [dispatch, selectedUser]);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 800,
                    maxWidth: "100%",
                    p: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                },
            }}
            ModalProps={{
                keepMounted: true, // improves performance on mobile
            }}
        >
            <Box
                sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    p: 0,
                    backgroundColor: "#fafafa",
                    "&::-webkit-scrollbar": { width: "6px" },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#ccc",
                        borderRadius: "4px",
                    },
                }}
            >

                {(!isMobile || (isMobile && selectedUser !== null)) && (
                    <Grid container spacing={1}>
                        <Grid item size={{ xs: 12, md: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: { xs: "100dvh", md: "min(700px, 100dvh)" },
                                    border: "1px solid #ddd",
                                    width: "100%",
                                }}
                            >
                                {/* Header - Fixed */}
                                <Box
                                    sx={{
                                        flexShrink: 0,
                                        borderBottom: "1px solid #ddd",
                                        backgroundColor: "#fff",
                                        zIndex: 10,
                                    }}
                                >
                                    <SocketProvider />
                                    {selectedUser !== null && <ConvoNavBar />}
                                </Box>

                                {/* Scrollable Body */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        overflow: "auto",
                                        backgroundColor: "#f9f9f9",
                                        p: 2,
                                        display: "flex",
                                        flexDirection: "column-reverse", // 👈 important for chat (newest at bottom)
                                        gap: 1,
                                        backgroundImage: selectedUser !== null ? `url(${convoBg})` : `url(${WaIntroBgImage})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                    }}
                                    id="scrollableChatDiv" // 👈 needed by InfiniteScroll
                                >
                                    {selectedUser !== null && (
                                        <InfiniteScroll
                                            dataLength={Object.values(waMessageChats?.[0]?.messages || {}).flat().length} // total messages currently loaded
                                            next={fetchPreviousChat} // function to load more
                                            hasMore={hasMoreChats} // boolean from Redux
                                            inverse={true} // 👈 important for chat scroll-up loading
                                            scrollableTarget="scrollableChatDiv" // 👈 matches Box id
                                            style={{ display: "flex", flexDirection: "column-reverse" }}
                                            loader={<p style={{ textAlign: "center" }}>Loading more messages...</p>}
                                        >
                                            {/* {selectedUser !== null && <Convo lastMsgRef={lastMsgRef} />} */}
                                            {
                                                chatPage === 1 ? (
                                                    loadingChats ? (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                height: "100%",
                                                                py: 2,
                                                            }}
                                                        >
                                                            <CircularProgress size={30} color="primary" />
                                                        </Box>
                                                    ) : (
                                                        selectedUser !== null && <Convo lastMsgRef={lastMsgRef} />
                                                    )
                                                ) : (
                                                    selectedUser !== null && <Convo lastMsgRef={lastMsgRef} />
                                                )
                                            }
                                        </InfiniteScroll>
                                    )}
                                </Box>

                                {/* Footer - Fixed */}
                                <Box
                                    sx={{
                                        flexShrink: 0,
                                        borderTop: "1px solid #ddd",
                                        backgroundColor: "#fff",
                                        zIndex: 10,
                                    }}
                                >
                                    {selectedUser !== null && <ConvoFooter scrollToLastMsg={scrollToLastMsg} />}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Drawer>
    );
}